import axios, { AxiosRequestConfig, AxiosResponse, Method } from 'axios';

export const axiosInstance = axios.create({
  baseURL: process.env.KOUTO_API_URL,
  timeout: 40 * 1000,
});

interface RequestOptions extends AxiosRequestConfig {}

const headers: Record<string, string> = {};

const axiosRequestWithBody =
  (method: Omit<Method, 'GET' | 'get' | 'DELETE' | 'delete'>) =>
  async <T, R>(url: string, data?: R, options?: RequestOptions): Promise<T> => {
    const response = await axiosInstance.request<T, AxiosResponse<T>, R>({
      method: method.toString(),
      url,
      data,
      headers: { ...headers, ...options?.headers },
      ...options,
    });
    return response.data;
  };

export const axiosRequestWithoutBody =
  (method: 'get' | 'GET' | 'delete' | 'DELETE') =>
  async <T>(url: string, options?: RequestOptions): Promise<T> => {
    if (method === 'get' || method === 'GET') {
      const response = await axiosInstance.request<T, AxiosResponse<T>>({
        method: method.toString(),
        url,
        headers: { ...headers, ...options?.headers },
        ...options,
      });
      return response.data;
    }
    const response = await axiosInstance.request<T, AxiosResponse<T>>({
      method: method.toString(),
      url,
      headers: { ...headers, ...options?.headers },
      ...options,
    });
    return response.data;
  };

export const get = axiosRequestWithoutBody('get');

export const post = axiosRequestWithBody('post');

export const patch = axiosRequestWithBody('patch');

export const put = axiosRequestWithBody('put');

export const deleteRequest = axiosRequestWithoutBody('delete');

export const setAxiosHeader = (key: string, value: string) => {
  if (key && value) {
    headers[key] = value;
  }
};
